/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */
/**
 * Compute the byte length of a UTF8 string.
 *
 * @param utf8 A UTF8 encoded string.
 * @returns The length of the string in bytes.
 */
export function byteLength(utf8: string): number {
    // returns the byte length of an utf8 string
    let s = utf8.length;

    for (let i = utf8.length - 1; i >= 0; i -= 1) {
        const code = utf8.charCodeAt(i);

        // ASCI codes.
        if (code > 0x7f && code <= 0x7ff) {
            s += 1;
        }
        // Unicode codes.
        else if (code > 0x7ff && code <= 0xffff) {
            s += 2;
        }

        if (code >= 0xdc00 && code <= 0xdfff) i -= 1; // trail surrogate
    }
    return s;
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/strings/byteLength.ts